import { ReplaySubject } from 'rxjs';

import { inject, Injectable } from '@angular/core';

import { TourIntercom, tourIntercoms } from '@app/core/models/tour.models';
import { IntercomService } from '@app/core/services/intercom.service';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { CustomerState } from '@app/core/store/states/customer/customer.state';
import { UserLanguage } from '@app/core/models/user.models';
import { lastValue } from '@app/shared/operators/last-value.operator';

@Injectable({
  providedIn: 'root',
})
export class TourIntercomService {
  readonly subject = new ReplaySubject<{ tourEnabled: boolean; source: 'intercom'; instance?: TourIntercom }>(1);

  readonly is = inject(IntercomService);

  readonly ts = inject(TranslateService);

  readonly isEssential = select(CustomerState.isEssentialSegment);

  enableIntercomTour(instance: TourIntercom): void {
    this.subject.next({ tourEnabled: true, source: 'intercom', instance });
  }

  disableIntercomTour(): undefined {
    this.subject.next({ tourEnabled: false, source: 'intercom' });
  }

  hideIntercomTour(): void {
    const currentInstance = lastValue(this.subject)?.instance;

    if (currentInstance) {
      this.subject.next({ tourEnabled: false, source: 'intercom', instance: currentInstance });
    }
  }

  unhideIntercomTour(): void {
    const currentInstance = lastValue(this.subject)?.instance;

    if (currentInstance) {
      this.subject.next({ tourEnabled: true, source: 'intercom', instance: currentInstance });
    }
  }

  start(instance: TourIntercom): void {
    const intercomData = tourIntercoms[instance];
    let intercomLanguageTourId = intercomData[this.ts.currentLang.toUpperCase() as UserLanguage];

    if (Array.isArray(intercomLanguageTourId) && intercomData.options?.splitBySegment) {
      intercomLanguageTourId = this.isEssential() ? intercomLanguageTourId[0] : intercomLanguageTourId[1];
    }

    if (typeof intercomLanguageTourId === 'number') {
      this.is.startTour(intercomLanguageTourId);
    }
  }
}
